// import React, { useState } from "react";
// import Cookies from "js-cookie";
// import {
//   Navigate,
//   Route,
//   Routes,
//   useLocation,
//   useNavigate,
//   useParams,
// } from "react-router-dom";
// import FolderContents from "../pages/Contract/FolderContents";
// import FolderChat from "../pages/Contract/FolderChat";
// import Chat from "../pages/chat/Chat";
// import ContractDetails from "../pages/Contract/ContractDetails";
// import Pricing from "../pages/pricing/Pricing";
// import PrivacyPage from "../pages/Privacy/PrivacyPage";
// import TermAndCondition from "../pages/Term&Condition/TermAndCondition";
// import Signin from "../pages/Login&Signup/Signin";
// import BlogPage from "../pages/Blog/BlogPage";
// import BlogDetails from "../pages/Blog/BlogDetails";
// import NotFoundPage from "../pages/NotFound/NotFoundPage";
// import Footer from "../pages/Footer/Footer";
// import SignupPage from "../pages/Login&Signup/SignupPage";
// import UploadFilePage from "../pages/UploadFile/UploadFilePage";
// import ChatTest from "../pages/chat/ChatTest";
// import Menu from "../pages/chat/Menu";
// import Layout from "../Layout/Layout";
// import Setting from "../pages/chat/setting/Setting";
// import PaymentSuccess from "../pages/pricing/PaymentSuccess";
// import Contract from "../pages/Contract/Contract_Data";
// import ChatApp from "../components/ChatApp";
// import ChatContract from "../components/ChatContract";
// import Invoice_chat from "../pages/Invoices/Invoice_chat";
// import Rfp_chat from "../pages/RFP_Manager/Rfp_chat";
import TenderSearch from "../pages/RFP_Manager/TenderSearch/TenderSearch";
import TenderDiscover from "../pages/RFP_Manager/TenderSearch/TenderDiscover";
import SavedSearchesPage from "../pages/RFP_Manager/TenderSearch/SavedSearchesPage";
import TenderDetail from "../pages/RFP_Manager/TenderSearch/TenderDetail";
// import Res_Writer from "../pages/RFP_Manager/Res_Writer";
// import PdfChat from "../components/pdfChat";
// import UploadProgress from "../pages/Contract/UploadProgress";
// import PaymentFailure from "../pages/pricing/PaymentFailure";
// import UploadExcel from "../pages/chat/Excel_chat/UploadExcel";
// import UploadYoutubeUrl from "../pages/chat/Youtube/UploadYoutubeUrl";
// import YoutubeSummary from "../pages/chat/Youtube/YoutubeSummary";
// import { ForgotPassword } from "../pages/Login&Signup/Forgot_password/ForgotPassword";
// import { ResetPassword } from "../pages/Login&Signup/Forgot_password/ResetPassword";
// import { CreatePassword } from "../pages/Login&Signup/Forgot_password/CreatePassword";
// import { CompleteAccount } from "../pages/Login&Signup/Complete_account/CompleteAccount";
// import OtpPage from "../pages/Login&Signup/OtpSection/OtpPage";
// import { AIcopilot } from "../pages/AI_Copilot/AIcopilot";
// import ContractChat from "../pages/Contract/contractChat";
// import ExcelChat from "../pages/Spreadsheets/ExcelChat";
// import Invoices from "../pages/Invoices/Invoice_Data";
// import Ocr_data from "../pages/Ocr_Data/Ocr_data";
// import CreateProposalQuestions from "../pages/RFP_Manager/CreateProposalQuestions";
// import Tags_data from "../pages/Tags/Tags_data";
// import Spreadsheets from "../pages/Spreadsheets/Spreadsheets_data";
// import Invoice_Details from "../pages/Invoices/Invoice_Details";
// import CopilotChat from "../pages/AI_Copilot/CopilotChat";
// import AccountPage from "../pages/chat/AccountPage";
// import GoogleDriveRedirect from "../pages/GoogleDriveRedirect/GoogleDriveRedirect";
// import GoogleCallbackHandler from "../pages/Ocr_Data/GoogleCallbackHandler";
// import RfpAnalyze from "../pages/RFP_Manager/RfpAnalyze";
// import RfpResponse from "../pages/RFP_Manager/RfpResponse";
// import RfpDashboard from "../pages/RFP_Manager/RfpDashboard";
// import Rfp_knowledgeBase from "../pages/RFP_Manager/Rfp_knowledgeBase";
// import CreatedProposal from "../pages/RFP_Manager/CreatedProposal";
// import Account from "../pages/Account/Account";
// import RfpFolderPage from "../pages/RFP_Manager/KbFolder/KbFolderPage";
// import Project from "../pages/RFP_Manager/Projects/Project";
// import MyProjects from "../pages/RFP_Manager/Projects/MyProjects";
// import SharedWithMe from "../pages/RFP_Manager/Projects/SharedWithMe";
// import ProjectsLayout from "../pages/RFP_Manager/Projects/ProjectsLayout";
// import KBChat from "../pages/RFP_Manager/KB-chat";
// import ProjectPage from "../pages/RFP_Manager/Projects/Project Page/ProjectPage";
// import ProjectChat from "../pages/RFP_Manager/Projects/ProjectChat";
// import ProposalPage from "../pages/RFP_Manager/Projects/Proposal/Proposal Page/ProposalPage";
// import ProposalAnalysisPage from "../pages/RFP_Manager/Projects/Proposal/ProposalAnalysisPage";
// import ProposalSectionView from "../pages/RFP_Manager/Projects/Proposal/Proposal Section View/ProposalSectionView";
// import AcceptInvitation from "../pages/Login&Signup/AcceptInvitation";
// import Extractor from "../pages/Extractor/Extractor";
// import QuestionnairePage from "../pages/RFP_Manager/Projects/Questionnaire/QuestionnairePage";
// import IndividualQuestionnairePage from "../pages/RFP_Manager/Projects/Questionnaire/IndividualQuestionnaire/IndividualQuestionnairePage";
// import ContractTable from "../pages/RFP_Manager/KnowledgeBase/KnowledgeBase";
// import ArchivedProjects from "../pages/RFP_Manager/Projects/ArchivedProjects";
// import ProjectFilesTab from "../pages/RFP_Manager/Projects/Project Page/ProjectFilesTab";
// import IntelligenceTab from "../pages/RFP_Manager/Projects/Project Page/IntelligenceTab";
// import RequirementsTab from "../pages/RFP_Manager/Projects/Project Page/RequirementsTab";
// import Analytics from "../pages/RFP_Manager/ChatAnalytics/Analytics";
// import ResponseEvaluationTab from "../pages/RFP_Manager/ChatAnalytics/ResponseEvaluationTab";
// import KnowledgeGapsTab from "../pages/RFP_Manager/ChatAnalytics/KnowledgeGapsTab";
// import AnalyticsLayout from "../pages/RFP_Manager/ChatAnalytics/AnalyticsLayout";
// const RedirectToProjectFiles = () => {
//   const { projectId, orgId } = useParams();
//   if (orgId) {
//     return (
//       <Navigate
//         to={`/rfp-projects/project/${projectId}/org/${orgId}/project-files`}
//         replace
//       />
//     );
//   }
//   return (
//     <Navigate to={`/rfp-projects/project/${projectId}/project-files`} replace />
//   );
// };

// const MainRoutes = () => {
//   const { pathname } = useLocation();
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(true);

//   const toggleMenu = () => {
//     setIsOpen((prev) => !prev);
//   };

//   const isFooterVisible =
//     ["/", "/pricing", "/privacy", "/term&condition", "/blog"].includes(
//       pathname
//     ) || pathname.startsWith("/blog/");

//   const token = Cookies.get("access_token");

//   const PrivateRoute = ({ children }) => {
//     const token = Cookies.get("access_token");
//     return token ? children : <Navigate to="/signin" replace />;
//   };

//   return (
//     <React.Fragment>
//       <Routes>
//         <Route
//           path="/"
//           element={
//             token ? (
//               <Navigate to="/uploadFile" replace />
//             ) : (
//               <Navigate to="/signin" replace />
//             )
//           }
//         />
//         <Route path="/privacy" element={<PrivacyPage />} />
//         <Route path="/signin" element={<Signin />} />
//         <Route path="/google/callback" element={<GoogleCallbackHandler />} />
//         <Route path="/accept-invitation" element={<AcceptInvitation />} />
//         <Route path="/term&condition" element={<TermAndCondition />} />
//         <Route path="/signup" element={<SignupPage />} />
//         <Route path="/blog" element={<BlogPage />} />
//         <Route path="/blog/:id" element={<BlogDetails />} />
//         <Route path="/menu" element={<Menu />} />
//         <Route path="/payment-failure/" element={<PaymentFailure />} />
//         <Route path="/request-password-reset" element={<ForgotPassword />} />
//         <Route path="/folder/:folderName" element={<FolderContents />} />
//         <Route
//           path="/reset-password/:uid/:token"
//           element={<CreatePassword />}
//         />
//         <Route path="/complete-account" element={<CompleteAccount />} />
//         <Route path="/otp" element={<OtpPage />} />
//         <Route
//           path="/payment-success/"
//           element={
//             <PrivateRoute>
//               <PaymentSuccess />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/uploadFile"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <UploadFilePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Invoices"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Invoices />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Ocr_Data"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Ocr_data />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Tags"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Tags_data />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/extractor"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Extractor />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-dashboard"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <RfpDashboard />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-knowledgeBase"
//           element={<Navigate to="/rfp-knowledgeBase/All-sources" replace />}
//         />
//         <Route
//           path="/rfp-knowledgeBase/All-sources"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContractTable />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-knowledgeBase/Content-library"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContractTable />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-knowledgeBase/Integrations"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContractTable />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-knowledgeBase/chat"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <KBChat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Project-chat/:projectId"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProjectChat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />{" "}
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId/project-overview"
//           element={
//             <PrivateRoute>
//               <RedirectToProjectFiles />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/project-overview"
//           element={
//             <PrivateRoute>
//               <RedirectToProjectFiles />
//             </PrivateRoute>
//           }
//         />
//         {/* Main Dashboard Wrapper WITH Org ID */}
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProjectPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         >
//           <Route index element={<Navigate to="project-files" replace />} />
//           <Route path="project-files" element={<ProjectFilesTab />} />
//           <Route path="intelligence" element={<IntelligenceTab />} />
//           <Route path="requirements" element={<RequirementsTab />} />
//         </Route>
//         {/* Main Dashboard Wrapper WITHOUT Org ID */}
//         <Route
//           path="/rfp-projects/project/:projectId"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProjectPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         >
//           <Route index element={<Navigate to="project-files" replace />} />
//           <Route path="project-files" element={<ProjectFilesTab />} />
//           <Route path="intelligence" element={<IntelligenceTab />} />
//           <Route path="requirements" element={<RequirementsTab />} />
//         </Route>
//         <Route
//           path="/rfp-projects"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProjectsLayout />
//               </Layout>
//             </PrivateRoute>
//           }
//         >
//           <Route index element={<Navigate to="my-projects" replace />} />
//           <Route path="my-projects" element={<MyProjects />} />
//           <Route path="shared-with-me" element={<SharedWithMe />} />
//           <Route path="archived-projects" element={<ArchivedProjects />} />
//         </Route>{" "}
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId/questionnaire"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <QuestionnairePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/questionnaire"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <QuestionnairePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId/questionnaire/:docId"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <IndividualQuestionnairePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/questionnaire/:docId"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <IndividualQuestionnairePage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId/proposal"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProposalPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/proposal"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProposalPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId/proposal/analysis"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProposalAnalysisPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/proposal/analysis"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProposalAnalysisPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/org/:orgId/proposal/analysis/section-view"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProposalSectionView />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-projects/project/:projectId/proposal/analysis/section-view"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ProposalSectionView />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         {/* Other Pages */}
//         <Route
//           path="/rfp-analyze"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <RfpAnalyze />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Response_writer"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Res_Writer />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-response"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <RfpResponse />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Spreadsheet"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Spreadsheets />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/ai-copilot"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <AIcopilot token={token} />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/google-drive-redirect"
//           element={
//             <PrivateRoute>
//               <GoogleDriveRedirect />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/CopilotChatScreen"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <CopilotChat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Invoices/Invoice_Details/:invoiceKey"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Invoice_Details />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/pricing"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Pricing />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Contract/FolderChat"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <FolderChat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Invoices/Invoice_chat"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <Invoice_chat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/created-proposal"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <CreatedProposal />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Rfp/Rfp_chat"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <Rfp_chat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/rfp-knowledgeBase/folder/:folderId"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <RfpFolderPage />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Spreadsheets/ExcelChat"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <ExcelChat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/account/*"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Account />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/folder"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <FolderContents />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Contract/contract-details/:contractKey"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ContractDetails />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/create-proposal-question/:pdf_key"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <CreateProposalQuestions />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/Contract/contractChat"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <ContractChat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/setting"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Setting />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/chat"
//           element={
//             <PrivateRoute>
//               <Layout open={false}>
//                 <Chat />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/chat/:id"
//           element={
//             <PrivateRoute>
//               <Chat />
//             </PrivateRoute>
//           }
//         />
//         <Route path="/folder-contents" element={<FolderContents />} />
//         <Route
//           path="/UploadYoutubeUrl"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <UploadYoutubeUrl />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/youtube-summary"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <YoutubeSummary />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/upload-excel"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <UploadExcel />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/excel-chat"
//           element={
//             <PrivateRoute>
//               <ExcelChat />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/excel-chat/:id"
//           element={
//             <PrivateRoute>
//               <ExcelChat />
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/payment"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <Pricing />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/test/c"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <ChatTest />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/analytics"
//           element={
//             <PrivateRoute>
//               <Layout>
//                 <AnalyticsLayout />
//               </Layout>
//             </PrivateRoute>
//           }
//         >
//           <Route
//             index
//             element={<Navigate to="response-evaluation" replace />}
//           />
//           <Route
//             path="response-evaluation"
//             element={<ResponseEvaluationTab />}
//           />
//           <Route path="knowledge-gaps" element={<KnowledgeGapsTab />} />
//         </Route>
//         <Route
//           path="/contract"
//           element={
//             <PrivateRoute>
//               <Layout isOpen={isOpen} toggleMenu={toggleMenu}>
//                 <Contract isMenuOpen={isOpen} />
//               </Layout>
//             </PrivateRoute>
//           }
//         />
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//     </React.Fragment>
//   );
// };

// export default MainRoutes;

import React, { useState } from "react";
import Cookies from "js-cookie";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

// Page Imports
import FolderContents from "../pages/Contract/FolderContents";
import FolderChat from "../pages/Contract/FolderChat";
import Chat from "../pages/chat/Chat";
import ContractDetails from "../pages/Contract/ContractDetails";
import Pricing from "../pages/pricing/Pricing";
import PrivacyPage from "../pages/Privacy/PrivacyPage";
import TermAndCondition from "../pages/Term&Condition/TermAndCondition";
import Signin from "../pages/Login&Signup/Signin";
import BlogPage from "../pages/Blog/BlogPage";
import BlogDetails from "../pages/Blog/BlogDetails";
import NotFoundPage from "../pages/NotFound/NotFoundPage";
import Footer from "../pages/Footer/Footer";
import UploadFilePage from "../pages/UploadFile/UploadFilePage";
import ChatTest from "../pages/chat/ChatTest";
import Menu from "../pages/chat/Menu";
import Layout from "../Layout/Layout";
import Setting from "../pages/chat/setting/Setting";
import PaymentSuccess from "../pages/pricing/PaymentSuccess";
import Contract from "../pages/Contract/Contract_Data";
import ChatApp from "../components/ChatApp";
import ChatContract from "../components/ChatContract";
import Invoice_chat from "../pages/Invoices/Invoice_chat";
import Rfp_chat from "../pages/RFP_Manager/Rfp_chat";
import Res_Writer from "../pages/RFP_Manager/Res_Writer";
import PdfChat from "../components/pdfChat";
import UploadProgress from "../pages/Contract/UploadProgress";
import PaymentFailure from "../pages/pricing/PaymentFailure";
import UploadExcel from "../pages/chat/Excel_chat/UploadExcel";
import UploadYoutubeUrl from "../pages/chat/Youtube/UploadYoutubeUrl";
import YoutubeSummary from "../pages/chat/Youtube/YoutubeSummary";
import { ForgotPassword } from "../pages/Login&Signup/Forgot_password/ForgotPassword";
import { ResetPassword } from "../pages/Login&Signup/Forgot_password/ResetPassword";
import { CreatePassword } from "../pages/Login&Signup/Forgot_password/CreatePassword";
import { CompleteAccount } from "../pages/Login&Signup/Complete_account/CompleteAccount";
import OtpPage from "../pages/Login&Signup/OtpSection/OtpPage";
import { AIcopilot } from "../pages/AI_Copilot/AIcopilot";
import ContractChat from "../pages/Contract/contractChat";
import ExcelChat from "../pages/Spreadsheets/ExcelChat";
import Invoices from "../pages/Invoices/Invoice_Data";
import Ocr_data from "../pages/Ocr_Data/Ocr_data";
import CreateProposalQuestions from "../pages/RFP_Manager/CreateProposalQuestions";
import Tags_data from "../pages/Tags/Tags_data";
import Spreadsheets from "../pages/Spreadsheets/Spreadsheets_data";
import Invoice_Details from "../pages/Invoices/Invoice_Details";
import CopilotChat from "../pages/AI_Copilot/CopilotChat";
import AccountPage from "../pages/chat/AccountPage";
import GoogleDriveRedirect from "../pages/GoogleDriveRedirect/GoogleDriveRedirect";
import GoogleCallbackHandler from "../pages/Ocr_Data/GoogleCallbackHandler";
import RfpAnalyze from "../pages/RFP_Manager/RfpAnalyze";
import RfpResponse from "../pages/RFP_Manager/RfpResponse";
import RfpDashboard from "../pages/RFP_Manager/RfpDashboard";
import RfpCopilotPage from "../pages/RFP_Manager/Copilot/RfpCopilotPage";
import NotificationsPage from "../pages/Notifications/NotificationsPage";
import Rfp_knowledgeBase from "../pages/RFP_Manager/Rfp_knowledgeBase";
import CreatedProposal from "../pages/RFP_Manager/CreatedProposal";
import Account from "../pages/Account/Account";
import RfpFolderPage from "../pages/RFP_Manager/KbFolder/KbFolderPage";
import Project from "../pages/RFP_Manager/Projects/Project";
import MyProjects from "../pages/RFP_Manager/Projects/MyProjects";
import ProjectsLayout from "../pages/RFP_Manager/Projects/ProjectsLayout";
import KBChat from "../pages/RFP_Manager/KB-chat";
import ProjectPage from "../pages/RFP_Manager/Projects/Project Page/ProjectPage";
import ProposalPage from "../pages/RFP_Manager/Projects/Proposal/Proposal Page/ProposalPage";
import ProposalAnalysisPage from "../pages/RFP_Manager/Projects/Proposal/ProposalAnalysisPage";
import ProposalSectionView from "../pages/RFP_Manager/Projects/Proposal/Proposal Section View/ProposalSectionView";
import AcceptInvitation from "../pages/Login&Signup/AcceptInvitation";
import Extractor from "../pages/Extractor/Extractor";
import QuestionnairePage from "../pages/RFP_Manager/Projects/Questionnaire/QuestionnairePage";
import IndividualQuestionnairePage from "../pages/RFP_Manager/Projects/Questionnaire/IndividualQuestionnaire/IndividualQuestionnairePage";
import FormsPage from "../pages/RFP_Manager/Projects/Forms/FormsPage";
import FormReviewPage from "../pages/RFP_Manager/Projects/Forms/FormReviewPage";
import ContractTable from "../pages/RFP_Manager/KnowledgeBase/KnowledgeBase";
import ArchivedProjects from "../pages/RFP_Manager/Projects/ArchivedProjects";
import ProjectFilesTab from "../pages/RFP_Manager/Projects/Project Page/ProjectFilesTab";
// import IntelligenceTab from "../pages/RFP_Manager/Projects/Project Page/IntelligenceTab";
import BidReadinessTab from "../pages/RFP_Manager/Projects/Project Page/BidReadinessTab";
import RequirementsTab from "../pages/RFP_Manager/Projects/Project Page/RequirementsTab";
import Analytics from "../pages/RFP_Manager/ChatAnalytics/Analytics";
import ResponseEvaluationTab from "../pages/RFP_Manager/ChatAnalytics/ResponseEvaluationTab";
import KnowledgeGapsTab from "../pages/RFP_Manager/ChatAnalytics/KnowledgeGapsTab";
import AnalyticsLayout from "../pages/RFP_Manager/ChatAnalytics/AnalyticsLayout";

// The old project chat, retired for Sensa: links and bookmarks to it open the
// same conversation the "Chat With Project" button now starts.
const RedirectToSensaProjectChat = () => {
  const { projectId } = useParams();
  const { state } = useLocation();
  return (
    <Navigate
      to="/rfp-copilot"
      replace
      state={{ chatWithProject: { projectId, projectName: state?.projectName } }}
    />
  );
};

const RedirectToProjectFiles = () => {
  const { projectId, orgId } = useParams();
  if (orgId) {
    return (
      <Navigate
        to={`/rfp-projects/project/${projectId}/org/${orgId}/project-files`}
        replace
      />
    );
  }
  return (
    <Navigate to={`/rfp-projects/project/${projectId}/project-files`} replace />
  );
};

// Boundary guard for project routes that carry an /org/:orgId segment.
// Navigation occasionally builds that segment from a missing value, leaving the
// literal "undefined"/"null" in the URL, which then propagates into every
// downstream useParams() read and leaks into APIs as ?organization_id=undefined.
// Validate here — the single chokepoint every project page is reached through —
// so a malformed org id can never reach a page. When invalid, recover by
// injecting the active workspace (selected_org_id) into the same path; if there
// is no workspace context at all, fall back to the projects list.
const RequireOrgId = ({ children }) => {
  const { orgId } = useParams();
  const location = useLocation();
  const isValid = orgId && orgId !== "undefined" && orgId !== "null";
  if (isValid) return children;

  const fallback = Cookies.get("selected_org_id");
  if (!fallback || fallback === "undefined" || fallback === "null") {
    return <Navigate to="/rfp-projects" replace />;
  }
  const fixedPath =
    location.pathname.replace(/\/org\/[^/]*/, `/org/${fallback}`) +
    location.search;
  return <Navigate to={fixedPath} replace />;
};

// Defined here, not inside MainRoutes. Declared inside, it was a new component
// type on every render, so React threw away the whole page below it and built
// it again on every navigation — including the ones a page makes itself when it
// writes its own filters into the URL.
const PrivateRoute = ({ children }) => {
  const token = Cookies.get("access_token");
  return token ? children : <Navigate to="/signin" replace />;
};

const MainRoutes = () => {
  const { pathname } = useLocation();
  const token = Cookies.get("access_token");

  return (
    <React.Fragment>
      <Routes>
        {/* ===================================== */}
        {/* GROUP 1: PUBLIC OR STANDALONE ROUTES  */}
        {/* ===================================== */}
        <Route
          path="/"
          element={
            token ? (
              // <Navigate to="/uploadFile" replace />
              <Navigate to="/rfp-dashboard" replace />
            ) : (
              <Navigate to="/signin" replace />
            )
          }
        />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/signin" element={<Signin key="signin" mode="signin" />} />
        <Route path="/google/callback" element={<GoogleCallbackHandler />} />
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="/term&condition" element={<TermAndCondition />} />
        <Route path="/signup" element={<Signin key="signup" mode="signup" />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/payment-failure/" element={<PaymentFailure />} />
        <Route path="/request-password-reset" element={<ForgotPassword />} />
        <Route
          path="/reset-password/:uid/:token"
          element={<CreatePassword />}
        />
        <Route path="/complete-account" element={<CompleteAccount />} />
        <Route path="/otp" element={<OtpPage />} />
        <Route path="/payment-success/" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />

        {/* Folders and standalone chat variants */}
        <Route path="/folder/:folderName" element={<FolderContents />} />
        <Route path="/folder-contents" element={<FolderContents />} />
        <Route
          path="/excel-chat"
          element={
            <PrivateRoute>
              <ExcelChat />
            </PrivateRoute>
          }
        />
        <Route
          path="/excel-chat/:id"
          element={
            <PrivateRoute>
              <ExcelChat />
            </PrivateRoute>
          }
        />
        <Route
          path="/chat/:id"
          element={
            <PrivateRoute>
              <Chat />
            </PrivateRoute>
          }
        />

        {/* Redirect Helpers */}
        <Route
          path="/rfp-projects/project/:projectId/org/:orgId/project-overview"
          element={
            <PrivateRoute>
              <RedirectToProjectFiles />
            </PrivateRoute>
          }
        />
        <Route
          path="/rfp-projects/project/:projectId/project-overview"
          element={
            <PrivateRoute>
              <RedirectToProjectFiles />
            </PrivateRoute>
          }
        />
        <Route
          path="/rfp-knowledgeBase"
          element={<Navigate to="/rfp-knowledgeBase/All-sources" replace />}
        />

        {/* ===================================== */}
        {/* GROUP 2: STANDARD LAYOUT (Menu Open)  */}
        {/* ===================================== */}
        <Route
          element={
            <PrivateRoute>
              <Layout defaultOpen={true} />
            </PrivateRoute>
          }
        >
          <Route path="/uploadFile" element={<UploadFilePage />} />
          <Route path="/Invoices" element={<Invoices />} />
          <Route path="/Ocr_Data" element={<Ocr_data />} />
          <Route path="/Tags" element={<Tags_data />} />
          <Route path="/extractor" element={<Extractor />} />
          <Route path="/rfp-dashboard" element={<RfpDashboard />} />
          <Route path="/tender-search" element={<TenderSearch />} />
          {/* Before :tenderId — a literal segment must win over the catch-all param. */}
          <Route path="/tender-search/saved" element={<SavedSearchesPage />} />
          <Route path="/tender-search/discover" element={<TenderDiscover />} />
          <Route path="/tender-search/:tenderId" element={<TenderDetail />} />
          <Route path="/rfp-copilot" element={<RfpCopilotPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />

          <Route path="/rfp-knowledgeBase/All-sources" element={<ContractTable />} />
          <Route path="/rfp-knowledgeBase/Memory" element={<ContractTable />} />
          <Route path="/rfp-knowledgeBase/Content-library" element={<ContractTable />} />
          <Route path="/rfp-knowledgeBase/Integrations" element={<ContractTable />} />
          <Route path="/rfp-knowledgeBase/chat" element={<KBChat />} />
          <Route path="/rfp-knowledgeBase/folder/:folderId" element={<RfpFolderPage />} />

          <Route path="/Project-chat/:projectId" element={<RedirectToSensaProjectChat />} />

          {/* Nested Dashboard Projects */}
          <Route
            path="/rfp-projects/project/:projectId/org/:orgId"
            element={
              <RequireOrgId>
                <ProjectPage />
              </RequireOrgId>
            }
          >
            <Route index element={<Navigate to="project-files" replace />} />
            <Route path="project-files" element={<ProjectFilesTab />} />
            {/* <Route path="intelligence" element={<IntelligenceTab />} /> */}
            <Route path="bid-readiness" element={<BidReadinessTab />} />
            <Route path="requirements" element={<RequirementsTab />} />
          </Route>

          <Route path="/rfp-projects/project/:projectId" element={<ProjectPage />}>
            <Route index element={<Navigate to="project-files" replace />} />
            <Route path="project-files" element={<ProjectFilesTab />} />
            {/* <Route path="intelligence" element={<IntelligenceTab />} /> */}
            <Route path="bid-readiness" element={<BidReadinessTab />} />
            <Route path="requirements" element={<RequirementsTab />} />
          </Route>

          <Route path="/rfp-projects" element={<ProjectsLayout />}>
            <Route index element={<Navigate to="my-projects" replace />} />
            <Route path="my-projects" element={<MyProjects />} />
            {/* Shared With Me was merged into the single Projects table. The old
                path stays as a redirect so existing links and bookmarks work. */}
            <Route path="shared-with-me" element={<Navigate to="../my-projects" replace />} />
            <Route path="archived-projects" element={<ArchivedProjects />} />
          </Route>

          {/* Questionnaire & Proposals */}
          <Route path="/rfp-projects/project/:projectId/org/:orgId/questionnaire" element={<RequireOrgId><QuestionnairePage /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/questionnaire" element={<QuestionnairePage />} />
          <Route path="/rfp-projects/project/:projectId/org/:orgId/questionnaire/:docId" element={<RequireOrgId><IndividualQuestionnairePage /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/questionnaire/:docId" element={<IndividualQuestionnairePage />} />
          <Route path="/rfp-projects/project/:projectId/org/:orgId/forms" element={<RequireOrgId><FormsPage /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/forms" element={<FormsPage />} />
          <Route path="/rfp-projects/project/:projectId/org/:orgId/forms/review/:jobId" element={<RequireOrgId><FormReviewPage /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/forms/review/:jobId" element={<FormReviewPage />} />

          <Route path="/rfp-projects/project/:projectId/org/:orgId/proposal/:step?" element={<RequireOrgId><ProposalPage /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/proposal/:step?" element={<ProposalPage />} />
          <Route path="/rfp-projects/project/:projectId/org/:orgId/proposal/analysis" element={<RequireOrgId><ProposalAnalysisPage /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/proposal/analysis" element={<ProposalAnalysisPage />} />
          <Route path="/rfp-projects/project/:projectId/org/:orgId/proposal/analysis/section-view" element={<RequireOrgId><ProposalSectionView /></RequireOrgId>} />
          <Route path="/rfp-projects/project/:projectId/proposal/analysis/section-view" element={<ProposalSectionView />} />

          <Route path="/rfp-analyze" element={<RfpAnalyze />} />
          <Route path="/Response_writer" element={<Res_Writer />} />
          <Route path="/rfp-response" element={<RfpResponse />} />
          <Route path="/Spreadsheet" element={<Spreadsheets />} />
          <Route path="/ai-copilot" element={<AIcopilot token={token} />} />
          <Route path="/CopilotChatScreen" element={<CopilotChat />} />
          <Route
            path="/Invoices/Invoice_Details/:invoiceKey"
            element={<Invoice_Details />}
          />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/payment" element={<Pricing />} />

          <Route path="/account/*" element={<Account />} />
          <Route path="/folder" element={<FolderContents />} />
          <Route
            path="/Contract/contract-details/:contractKey"
            element={<ContractDetails />}
          />
          <Route
            path="/create-proposal-question/:pdf_key"
            element={<CreateProposalQuestions />}
          />
          <Route path="/setting" element={<Setting />} />

          <Route path="/UploadYoutubeUrl" element={<UploadYoutubeUrl />} />
          <Route path="/youtube-summary" element={<YoutubeSummary />} />
          <Route path="/upload-excel" element={<UploadExcel />} />
          <Route path="/test/c" element={<ChatTest />} />

          <Route path="/contract" element={<Contract />} />

          <Route path="/analytics" element={<AnalyticsLayout />}>
            <Route
              index
              element={<Navigate to="response-evaluation" replace />}
            />
            <Route
              path="response-evaluation"
              element={<ResponseEvaluationTab />}
            />
            <Route path="knowledge-gaps" element={<KnowledgeGapsTab />} />
          </Route>
        </Route>

        {/* ===================================== */}
        {/* GROUP 3: COMPACT LAYOUT (Menu Closed) */}
        {/* ===================================== */}
        <Route
          element={
            <PrivateRoute>
              <Layout defaultOpen={false} />
            </PrivateRoute>
          }
        >
          <Route path="/Contract/FolderChat" element={<FolderChat />} />
          <Route path="/Invoices/Invoice_chat" element={<Invoice_chat />} />
          <Route path="/created-proposal" element={<CreatedProposal />} />
          <Route path="/Rfp/Rfp_chat" element={<Rfp_chat />} />
          <Route path="/Spreadsheets/ExcelChat" element={<ExcelChat />} />
          <Route path="/Contract/contractChat" element={<ContractChat />} />
          <Route path="/chat" element={<Chat />} />
        </Route>

        <Route path="/google-drive-redirect" element={<PrivateRoute><GoogleDriveRedirect /></PrivateRoute>} />

        {/* Catch-all */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </React.Fragment>
  );
};

export default MainRoutes;
